<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Privacy Policy</h2>
            <ul>
                <li>
                    <a routerLink="/">
                        Home
                    </a>
                </li>
                <li>
                    Privacy Policy
                </li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->


<!-- Start privacy Policy Area -->
<section class="features-area ptb-110">
    <div class="container">
        <div class="overview-box">
            <div class="row" style="text-align: justify;">
                <h1>
                    Privacy Policy
                </h1>

                <p class="mt-2">
                    We respect your privacy and are committed to protecting it through our compliance with this privacy
                    policy (“Policy”). This Policy describes the types of information we may collect from you or that
                    you may provide (“Personal Information”) on the vocbot.ai website (“Website” or “Service”) and
                    any of its related products and services (collectively, “Services”), and our practices for
                    collecting, using, maintaining, protecting, and disclosing that Personal Information. It also
                    describes the choices available to you regarding our use of your Personal Information and how you
                    can access and update it.
                <p>
                    This Policy is a legally binding agreement between you (“User”, “you” or “your”) and VOCBOT.AI
                    TECHNOLOGY PVT LTD (doing business as “VOCBOT.AI”, “we”, “us” or “our”). If you are entering into
                    this Policy on behalf of a business or other legal entity, you represent that you have the authority
                    to bind such entity to this Policy, in which case the terms “User”, “you” or “your” shall refer to
                    such entity. If you do not have such authority, or if you do not agree with the terms of this
                    Policy, you must not accept this Policy and may not access and use the Website and Services. By
                    accessing and using the Website and Services, you acknowledge that you have read, understood, and
                    agree to be bound by the terms of this Policy. This Policy does not apply to the practices of
                    companies that we do not own or control, or to individuals that we do not employ or manage.
                </p>
                <div class="mt-3 mb-3">
                    <h1>Table of contents</h1>
                    <ol class="mt-3 mb-3">
                        <li>Collection of personal information</li>
                        <li>Use and processing of collected
                                information</li>
                        <li>Payment processing</li>
                        <li>Disclosure of information</li>
                        <li>Retention of information</li>
                        <li>Cookies</li>
                        <li>Data analytics</li>
                        <li>Privacy of children</li>
                        <li>Do Not Track signals</li>
                        <li>Links to other resources</li>
                        <li>Information security</li>
                        <li>Data breach</li>
                        <li>Changes and amendments</li>
                        <li>Acceptance of this policy</li>
                        <li>Contacting us</li>
                    </ol>
                </div>

                <h1 class="mt-3 mb-3">
                    Collection of personal information
                </h1>

                <p>You can access and use the Website and Services without telling us who you are or revealing any
                    information by which someone could identify you as a specific, identifiable individual. If, however,
                    you wish to use some of the features offered on the Website, you may be asked to provide certain
                    Personal Information (for example, your name and e-mail address).</p>
                <p>We receive and store any information you knowingly provide to us when you make a purchase, or fill
                    any forms on the Website. When required, this information may include the following:</p>
                <div>
                    <ul class="list">
                        <li>
                            <i class='bx bx-check'></i>
                            Account details (such as user name, unique user ID, password, etc)
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            Contact information (such as email address, phone number, etc)
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            Basic personal information (such as name, country of residence, etc)
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            Proof of identity (such as a photocopy of a government ID)
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            Payment information (such as credit card details, bank details, etc)
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            Geolocation data of your device (such as latitude and longitude)
                        </li>

                    </ul>
                </div>
                <p>You can choose not to provide us with your Personal Information, but then you may not be able to take
                    advantage of some of the features on the Website. Users who are uncertain about what information is
                    mandatory are welcome to contact us.</p>

                <h1 class="mt-3 mb-3">
                    Use and processing of collected information
                </h1>
                <p>We act as a data controller and a data processor when handling Personal Information, unless we have
                    entered into a data processing agreement with you in which case you would be the data controller and
                    we would be the data processor.</p>

                <p>Our role may also differ depending on the specific situation involving Personal Information. We act
                    in the capacity of a data controller when we ask you to submit your Personal Information that is
                    necessary to ensure your access and use of the Website and Services. In such instances, we are a
                    data controller because we determine the purposes and means of the processing of Personal
                    Information.</p>

                <p>We act in the capacity of a data processor in situations when you submit Personal Information through
                    the Website and Services. We do not own, control, or make decisions about the submitted Personal
                    Information, and such Personal Information is processed only in accordance with your instructions.
                    In such instances, the User providing Personal Information acts as a data controller.</p>


                <p>In order to make the Website and Services available to you, or to meet a legal obligation, we may
                    need to collect and use certain Personal Information. If you do not provide the information that we
                    request, we may not be able to provide you with the requested products or services. Any of the
                    information we collect from you may be used for the following purposes:</p>

                <ul>
                    <li>Create and manage user accounts</li>
                    <li>Fulfill and manage orders</li>
                    <li>Deliver products or services</li>
                    <li>Improve products and services</li>
                    <li>Send administrative information</li>
                    <li>Send marketing and promotional communications</li>
                    <li>Send product and service updates</li>
                    <li>Respond to inquiries and offer support</li>
                    <li>Request user feedback</li>
                    <li>Improve user experience</li>
                    <li>Post customer testimonials</li>
                    <li>Protect from abuse and malicious users</li>
                    <li>Respond to legal requests and prevent harm</li>
                    <li>Run and operate the Website and Services</li>
                </ul>
                <p>Processing your Personal Information depends on how you interact with the Website and Services, where
                    you are located in the world and if one of the following applies: (a) you have given your consent
                    for one or more specific purposes; (b) provision of information is necessary for the performance of
                    this Policy with you and/or for any pre-contractual obligations thereof; (c) processing is necessary
                    for compliance with a legal obligation to which you are subject; (d) processing is related to a task
                    that is carried out in the public interest or in the exercise of official authority vested in us;
                    (e) processing is necessary for the purposes of the legitimate interests pursued by us or by a third
                    party.</p>

                <p>Note that under some legislations we may be allowed to process information until you object to such
                    processing by opting out, without having to rely on consent or any other of the legal bases. In any
                    case, we will be happy to clarify the specific legal basis that applies to the processing, and in
                    particular whether the provision of Personal Information is a statutory or contractual requirement,
                    or a requirement necessary to enter into a contract.</p>

                <h1 class="mt-3 mb-3">
                    Payment processing
                </h1>
                <p>In case of Services requiring payment, you may need to provide your credit card details or other
                    payment account information, which will be used solely for processing payments. We use third-party
                    payment processors (“Payment Processors”) to assist us in processing your payment information
                    securely.</p>

                <p>Payment Processors adhere to the latest security standards as managed by the PCI Security Standards
                    Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover.
                    Sensitive and private data exchange happens over a SSL secured communication channel and is
                    encrypted and protected with digital signatures, and the Website and Services are also in compliance
                    with strict vulnerability standards in order to create as secure of an environment as possible for
                    Users. We will share payment data with the Payment Processors only to the extent necessary for the
                    purposes of processing your payments, refunding such payments, and dealing with complaints and
                    queries related to such payments and refunds.</p>

                <p>Please note that the Payment Processors may collect some Personal Information from you, which allows
                    them to process your payments (e.g., your email address, address, credit card details, and bank
                    account number) and handle all the steps in the payment process through their systems, including
                    data collection and data processing. Where necessary for processing future or recurring payments and
                    subject to your prior consent, your financial information will be stored in encrypted form on secure
                    servers of our Payment Processors. The Payment Processors’ use of your Personal Information is
                    governed by their respective privacy policies which may or may not contain privacy protections as
                    protective as this Policy. We suggest that you review their respective privacy policies.</p>

                <h1 class="mt-3 mb-3">
                    Disclosure of information
                </h1>
                <p>Depending on the requested Services or as necessary to complete any transaction or provide any
                    Service you have requested, we may share your information with our contracted companies, and service
                    providers (collectively, “Service Providers”) we rely upon to assist in the operation of the Website
                    and Services available to you and whose privacy policies are consistent with ours or who agree to
                    abide by our policies with respect to Personal Information. We will not share any personally
                    identifiable information with third parties and will not share any information with unaffiliated
                    third parties.</p>
                <p>Service Providers are not authorized to use or disclose your information except as necessary to
                    perform services on our behalf or comply with legal requirements. Service Providers are given the
                    information they need only in order to perform their designated functions, and we do not authorize
                    them to use or disclose any of the provided information for their own marketing or other purposes.
                </p>
                <p>We may also disclose any Personal Information we collect, use or receive if required or permitted by
                    law, such as to comply with a subpoena or similar legal process, and when we believe in good faith
                    that disclosure is necessary to protect our rights, protect your safety or the safety of others,
                    investigate fraud, or respond to a government request.</p>

                <h1 class="mt-3 mb-3">
                    Retention of information
                </h1>
                <p>We will retain and use your Personal Information for the period necessary to comply with our legal
                    obligations, as long as your user account remains active, until the purchase order or Services are
                    fulfilled, until our and our affiliates and partners obligations are fulfilled, to enforce our
                    Policy, resolve disputes, and unless a longer retention period is required or permitted by law.</p>
                <p>We may use any aggregated data derived from or incorporating your Personal Information after you
                    update or delete it, but not in a manner that would identify you personally. Once the retention
                    period expires, Personal Information shall be deleted. Therefore, the right to access, the right to
                    erasure, the right to rectification, and the right to data portability cannot be enforced after the
                    expiration of the retention period.</p>
                <h1 class="mt-3 mb-3">
                    Cookies
                </h1>
                <p>Our Website and Services use “cookies” to help personalize your online experience. A cookie is a text
                    file that is placed on your hard disk by a web page server. Cookies cannot be used to run programs
                    or deliver viruses to your computer. Cookies are uniquely assigned to you, and can only be read by a
                    web server in the domain that issued the cookie to you. If you choose to decline cookies, you may
                    not be able to fully experience the features of the Website and Services.</p>

                <p>We may use cookies to collect, store, and track information for security and personalization, to
                    operate the Website and Services, and for statistical purposes. For further information on the
                    cookies we collect and their purpose, see our cookie policy. Please note that
                    you have the ability to accept or decline cookies. Most web browsers automatically accept cookies by
                    default, but you can modify your browser settings to decline cookies if you prefer.</p>

                <h1 class="mt-3 mb-3">
                    Data analytics
                </h1>
                <p>Our Website and Services may use third-party analytics tools that use cookies, web beacons, or other
                    similar information-gathering technologies to collect standard internet activity and usage
                    information. The information gathered is used to compile statistical reports on User activity such
                    as how often Users visit our Website and Services, what pages they visit and for how long, etc. We
                    use the information obtained from these analytics tools to monitor the performance and improve our
                    Website and Services. We do not use third-party analytics tools to track or to collect any
                    personally identifiable information of our Users and we will not associate any information gathered
                    from the statistical reports with any individual User.</p>

                <h1 class="mt-3 mb-3">
                    Privacy of children
                </h1>

                <p>We do not knowingly collect any Personal Information from children under the age of 18. If you are
                    under the age of 18, please do not submit any Personal Information through the Website and Services.
                    If you have reason to believe that a child under the age of 18 has provided Personal Information to
                    us through the Website and Services, please contact us to request that we delete that child’s
                    Personal Information from our Services.</p>
                <p>We encourage parents and legal guardians to monitor their children’s Internet usage and to help
                    enforce this Policy by instructing their children never to provide Personal Information through the
                    Website and Services without their permission. We also ask that all parents and legal guardians
                    overseeing the care of children take the necessary precautions to ensure that their children are
                    instructed to never give out Personal Information when online without their permission.</p>

                <h1 class="mt-3 mb-3">
                    Do Not Track signals
                </h1>
                <p>Some browsers incorporate a Do Not Track feature that signals to websites you visit that you do not
                    want to have your online activity tracked. Tracking is not the same as using or collecting
                    information in connection with a website. For these purposes, tracking refers to collecting
                    personally identifiable information from users who use or visit a website or online service as they
                    move across different websites over time. How browsers communicate the Do Not Track signal is not
                    yet uniform. As a result, the Website and Services are not yet set up to interpret or respond to Do
                    Not Track signals communicated by your browser. Even so, as described in more detail throughout this
                    Policy, we limit our use and collection of your Personal Information. </p>

                <h1 class="mt-3 mb-3">
                    Links to other resources
                </h1>


                <p>The Website and Services contain links to other resources that are not owned or controlled by us.
                    Please be aware that we are not responsible for the privacy practices of such other resources or
                    third parties. We encourage you to be aware when you leave the Website and Services and to read the
                    privacy statements of each and every resource that may collect Personal Information.</p>

                <h1 class="mt-3 mb-3">
                    Information security
                </h1>
                <p>We secure information you provide on computer servers in a controlled, secure environment, protected
                    from unauthorized access, use, or disclosure. We maintain reasonable administrative, technical, and
                    physical safeguards in an effort to protect against unauthorized access, use, modification, and
                    disclosure of Personal Information in our control and custody. However, no data transmission over
                    the Internet or wireless network can be guaranteed.</p>
                <p>Therefore, while we strive to protect your Personal Information, you acknowledge that (a) there are
                    security and privacy limitations of the Internet which are beyond our control; (b) the security,
                    integrity, and privacy of any and all information and data exchanged between you and the Website and
                    Services cannot be guaranteed; and (c) any such information and data may be viewed or tampered with
                    in transit by a third party, despite best efforts.</p>
                <p>As the security of Personal Information depends in part on the security of the device you use to
                    communicate with us and the security you use to protect your credentials, please take appropriate
                    measures to protect this information.</p>

                <h1 class="mt-3 mb-3">
                    Data breach
                </h1>

                <p>In the event we become aware that the security of the Website and Services has been compromised or
                    Users’ Personal Information has been disclosed to unrelated third parties as a result of external
                    activity, including, but not limited to, security attacks or fraud, we reserve the right to take
                    reasonably appropriate measures, including, but not limited to, investigation and reporting, as well
                    as notification to and cooperation with law enforcement authorities. In the event of a data breach,
                    we will make reasonable efforts to notify affected individuals if we believe that there is a
                    reasonable risk of harm to the User as a result of the breach or if notice is otherwise required by
                    law. When we do, we will post a notice on the Website, send you an email, get in touch with you over
                    the phone, mail you a letter.</p>

                <h1 class="mt-3 mb-3">
                    Changes and amendments
                </h1>
                <p>We reserve the right to modify this Policy or its terms related to the Website and Services at any
                    time at our discretion. When we do, we will revise the updated date at the bottom of this page. We
                    may also provide notice to you in other ways at our discretion, such as through the contact
                    information you have provided.</p>
                <p>An updated version of this Policy will be effective immediately upon the posting of the revised
                    Policy unless otherwise specified. Your continued use of the Website and Services after the
                    effective date of the revised Policy (or such other act specified at that time) will constitute your
                    consent to those changes. However, we will not, without your consent, use your Personal Information
                    in a manner materially different than what was stated at the time your Personal Information was
                    collected.</p>


                <h1 class="mt-3 mb-3">
                    Acceptance of this policy
                </h1>
                <p>You acknowledge that you have read this Policy and agree to all its terms and conditions. By
                    accessing and using the Website and Services and submitting your information you agree to be bound
                    by this Policy. If you do not agree to abide by the terms of this Policy, you are not authorized to
                    access or use the Website and Services.</p>


                <h1 class="mt-3 mb-3">
                    Contacting us
                </h1>
                <p>If you have any questions regarding the information we may hold about you or if you wish to exercise
                    your rights, you may use the following data subject request form to submit your request:</p>
                <p>If you have any other questions, concerns, or complaints regarding this Policy, we encourage you to
                    contact us using the details below:</p>





                <p>
                    <strong>Email-id:</strong>
                    <a href="mailto: info@vocbot.ai" style="display: contents !important;color: blue;">
                        info@vocbot.ai
                    </a>
                </p>
                <p>
                    <strong>Phone Number:</strong>
                    <a href="tel:+91-9826323332" style="display: contents !important;">
                        +91-9826323332
                    </a>
                </p>
                <p>
                    <strong>Address:</strong>
                    43 Pratap Nagar, &nbsp;Manik Bagh Road, &nbsp;Near Gurunanak Dharmashala &nbsp;Indore (M.P.),
                    &nbsp;452001
                </p>

                <h3 class="mt-2" style="float: right;">
                    <strong>
                        Last updated:
                    </strong>
                    &nbsp; March 27, 2024
                    <!-- &nbsp;{{myDate | date: 'medium' }} -->
                </h3>
            </div>
        </div>
    </div>
   
</section>